import axios from "axios";
import { showAlert } from "./alert";

export const prepPallet = async (pallet) => {
  try {
    const res = await axios({
      method: "POST",
      url: `/api/v1/pallets/${pallet}/prep`,
      data: pallet,
    });
    if (res.data.status === "success") {
      showAlert("success", `Upload successful!`);
      window.setTimeout(() => {
        location.reload();
      }, 1000);
    }
  } catch (err) {
    showAlert("error", err.response.data.message);
  }
};
